import dayjs from 'dayjs'

export function wait(ms: number): Promise<void> {
  return new Promise(resolve => {
    setTimeout(() => resolve(), ms)
  })
}

export function scheduleDailyTask(callback: () => void, startInMs?: number): void {
  const dailyInterval = 24 * 60 * 60 * 1000
  const defaultStartTime = dayjs().add(1, 'day').startOf('day').diff(dayjs())
  return scheduleTask(callback, dailyInterval, startInMs || defaultStartTime)
}

export function scheduleTask(callback: () => void, interval: number, startInMs?: number): void {
  setTimeout(() => {
    callback()
    setInterval(callback, interval)
  }, startInMs)
}
